<template>
  <section class="rm-surface-card overflow-hidden" :aria-label="label">
    <header
      class="condition-group-card__header flex items-center justify-between gap-2.5 border-b border-line py-2.5 pr-3 pl-4">
      <div class="flex min-h-7 min-w-0 flex-wrap items-center gap-2 text-[13px] leading-none font-bold text-heading">
        <span>{{ label }}</span>
        <slot name="meta" />
      </div>
      <button
        v-if="removable"
        type="button"
        class="inline-flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-faint transition-colors duration-150 hover:bg-overlay hover:text-danger focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-primary"
        :aria-label="`Remove ${label.toLowerCase()}`"
        title="Remove group"
        @click="emit('remove')">
        <TrashIcon class="size-[15px]" aria-hidden="true" />
      </button>
    </header>
    <div class="flex flex-col gap-1.5 px-4 py-3">
      <slot />
      <button
        v-if="addOperator"
        type="button"
        class="mt-1 -ml-2 inline-flex cursor-pointer items-center gap-[5px] self-start rounded-md px-2 py-1.5 text-[13px] leading-none font-semibold transition-colors duration-150 hover:bg-overlay focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-primary"
        :class="operatorTextClass[addOperator]"
        @click="emit('add')">
        <PlusIcon class="size-[13px]" aria-hidden="true" />
        Add {{ addOperator.toUpperCase() }} condition
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { PlusIcon, TrashIcon } from '@heroicons/vue/24/outline'
import { operatorTextClass } from '../services/conditionSummary'
import type { LogicOperator } from '../services/conditionSummary'

defineProps<{
  label: string
  removable?: boolean
  /** Operator joining this group's rules; omit to hide the add button. */
  addOperator?: LogicOperator | null
}>()

const emit = defineEmits<{ remove: []; add: [] }>()
</script>

<style scoped>
.condition-group-card__header {
  background: color-mix(in srgb, var(--rm-canvas) 60%, var(--p-card-background));
}
</style>
